import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useBetterAuthConvexAuth } from '../../hooks/useAppAuth';

/**
 * PrivateRoute component that requires authentication.
 * Uses Better Auth for authentication state and Convex for user profile.
 */
const PrivateRoute: React.FC = () => {
  const { isLoaded, isSignedIn, isLoadingProfile } = useBetterAuthConvexAuth();

  // Show loading while Better Auth is initializing
  if (!isLoaded) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-green-500"></div>
      </div>
    );
  }

  // Not signed in - redirect to login
  if (!isSignedIn) {
    return <Navigate to="/login" replace />;
  }

  // Signed in but loading profile
  if (isLoadingProfile) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="flex flex-col items-center">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-green-500 mb-4"></div>
          <p className="text-gray-600">Loading your profile...</p>
        </div>
      </div>
    );
  }

  return <Outlet />;
};

export default PrivateRoute;
